import LayoutPage from "../../Components/LayoutPage"
import Buttons from "./Components/Buttons"
import RulesList from "./Components/RulesList"

export default function Rules() {
  return (
    <LayoutPage activeIndex={12} navItems={["مدیریت قوانین"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto">
      <Buttons/>
      <RulesList/>
    </LayoutPage>
  )
}